import React from 'react';
import { UploadCloudIcon } from 'lucide-react';
export const Hero = () => {
  return <section className="w-full py-16 md:py-24 px-6 md:px-12 bg-gradient-to-b from-white to-green-50 dark:from-gray-900 dark:to-gray-800" data-id="element-71">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center" data-id="element-72">
        <div className="md:w-3/5 mb-10 md:mb-0 md:pr-6" data-id="element-73">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-6" data-id="element-74">
            Hit CMS price transparency compliance in &lt;30 days—
            <span className="text-green-600 dark:text-green-400" data-id="element-75">
              guaranteed.
            </span>
          </h1>
          <p className="text-lg md:text-xl text-gray-600 dark:text-gray-300 mb-8" data-id="element-76">
            Upload your pricing files; we normalize to the CMS schema, fix gaps,
            and deliver compliant, machine-readable files. If CMS flags you, we
            pay the penalty.
          </p>
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-77">
            <a href="#contact" className="flex items-center justify-center px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-md text-base font-medium transition-colors" data-id="element-78">
              Schedule Demo
            </a>
            <a href="#contact" className="flex items-center justify-center px-6 py-3 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-md text-base font-medium transition-colors" data-id="element-79">
              Contact Us
            </a>
          </div>
        </div>
        <div className="md:w-2/5" data-id="element-80">
          <div className="relative flex justify-center items-center" data-id="element-81">
            <div className="w-full rounded-lg overflow-hidden shadow-md border border-gray-300 dark:border-gray-700 transform md:scale-100" data-id="element-82">
              <div className="bg-gray-100 dark:bg-gray-800 border-b border-gray-300 dark:border-gray-700 px-4 py-1" data-id="element-83">
                <div className="flex items-center" data-id="element-84">
                  <div className="flex space-x-2" data-id="element-85">
                    <div className="w-2 h-2 rounded-full bg-red-500" data-id="element-86"></div>
                    <div className="w-2 h-2 rounded-full bg-yellow-500" data-id="element-87"></div>
                    <div className="w-2 h-2 rounded-full bg-green-500" data-id="element-88"></div>
                  </div>
                  <div className="ml-4 flex-1 bg-white dark:bg-gray-700 rounded-md px-3 py-.3 text-xs text-gray-500 dark:text-gray-400 truncate" data-id="element-89">
                    roothealth.com/dashboard
                  </div>
                </div>
              </div>
              <div className="bg-white dark:bg-gray-900 overflow-hidden" data-id="element-90">
                <div className="transform-gpu scale-115 origin-top" data-id="element-91">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gNfQgebUPT9eR4VD4KBb7z/Screenshot_2025-09-29_at_9.48.26_PM.png" alt="RootHealth dashboard showing CMS compliance status and data transformation interface" className="w-full h-auto" data-id="element-92" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};